import { render, staticRenderFns } from "./EditorSlider.vue?vue&type=template&id=6450de7b&scoped=true&"
import script from "./EditorSlider.vue?vue&type=script&lang=js&"
export * from "./EditorSlider.vue?vue&type=script&lang=js&"
import style0 from "./EditorSlider.vue?vue&type=style&index=0&id=6450de7b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6450de7b",
  null
  
)

export default component.exports